export const DEFAULT_API_POLLING_TIME_INTERVAL: number = 20000;